///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbDateInputBaseComponent } from './../date-input.base.component';
import { CalendarComponent } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'kb-calendar',
    templateUrl: './calendar.component.html',
})
export class KbCalendarComponent extends KbDateInputBaseComponent {
    @ViewChild('calendar')
    public calendar: CalendarComponent;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/calendar/calendar.component.ts